import {
	Description,
	Dialog,
	DialogPanel,
	DialogTitle
} from '@headlessui/react';

import Router from 'next/router';

export default function errorsDialog({
	isOpen,
	setIsOpen,
	setIsLoading,
	error
}) {
	return (
		<>
			<Dialog
				open={isOpen}
				onClose={() => setIsOpen(false)}
				transition
				className="fixed inset-0 flex w-screen items-center justify-center bg-black/30 p-4 transition duration-300 ease-out data-closed:opacity-0"
			data-sentry-element="Dialog" data-sentry-source-file="index.jsx">
				<DialogPanel className="max-w-lg space-y-4 bg-white p-12" data-sentry-element="DialogPanel" data-sentry-source-file="index.jsx">
					<DialogTitle className="font-bold" data-sentry-element="DialogTitle" data-sentry-source-file="index.jsx">
						<div>
							There was an issue submitting your application.
							<span className="block">
								Someone has been notified.
							</span>
						</div>
					</DialogTitle>
					{error && (
						<p role="alert" className="font-semibold text-red-600">
							{error}
						</p>
					)}
					<Description data-sentry-element="Description" data-sentry-source-file="index.jsx">
						Please check fields and try again. If you continue to
						have problems, please contact support.
					</Description>

					<div className="flex justify-evenly mt-4">
						<button
							className="px-6 py-2 rounded-lg bg-emerald-600 text-white col-span-2"
							onClick={() => {
								setIsLoading(false);
								setIsOpen(false);
							}}
						>
							Close and Try Again
						</button>
						<button
							className="px-6 py-2 rounded-lg bg-gray-500 text-white col-span-1"
							onClick={() => {
								Router.push('/help');
							}}
						>
							Contact Support
						</button>
					</div>
				</DialogPanel>
			</Dialog>
		</>
	);
}
